import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../../utils/apiClient'
import Logo from '../../media/logo.svg'
function Feedback() {
	const [selectedCategory, setSelectedCategory] = useState('')
	const [message, setMessage] = useState('')
	const [isSubmitted, setIsSubmitted] = useState(false)
	const [extensionVersion, setExtensionVersion] = useState(null)
	const [isSubmitting, setIsSubmitting] = useState(false)

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)

		const version = urlParams.get('version')
		if (version) {
			setExtensionVersion(version)
		}
	}, [])

	const feedbackOptions = [
		{
			id: 'difficulty',
			label: 'I had difficulty using it',
			title: 'Difficult to use or navigate',
			placeholder:
				'Please tell us which feature you find hard to use and how can we make it better.',
		},
		{
			id: 'features',
			label: 'It lacked the features I needed',
			title: 'Missing features',
			placeholder:
				'Please tell us which features you need that are currently missing.',
		},
		{
			id: 'performance',
			label: 'Performance issues (e.g., slow, buggy)',
			title: 'Performance issues',
			placeholder: 'Please describe the performance issues you experienced.',
		},
		{
			id: 'price',
			label: 'Price over budget',
			title: 'Price concerns',
			placeholder: 'Please tell us more about your pricing concerns.',
		},
		{
			id: 'alternative',
			label: 'Found an alternative',
			title: 'Found an alternative',
			placeholder:
				'Please tell us which alternative you found and what made it better for your needs.',
		},
		{
			id: 'privacy',
			label: 'Privacy concerns',
			title: 'Privacy concerns',
			placeholder: 'Please tell us more about your privacy concerns.',
		},
		{
			id: 'other',
			label: 'Other Reasons',
			title: 'Other Reasons',
			placeholder: 'Please tell us why you are uninstalling LoadLine.',
		},
	]

	const handleRadioChange = id => {
		setSelectedCategory(id)
		setMessage('')
	}

	const handleBack = () => {
		setSelectedCategory('')
		setMessage('')
	}

	const getSelectedOption = () => {
		return feedbackOptions.find(option => option.id === selectedCategory)
	}

	const handleSubmit = async () => {
		setIsSubmitting(true)
		
		try {
			const response = await api.post(
				'/api/feedback/submit',
				{
					category: selectedCategory,
					message: message,
					extensionVersion: extensionVersion,
				}
			)

			if (response.data.success) {
				setTimeout(() => {
					setIsSubmitted(true)
				}, 500)
			} else {
				alert(
					response.data.message ||
						'Failed to submit feedback. Please try again.'
				)
				setIsSubmitting(false)
			}
		} catch (error) {
			setTimeout(() => {
				setIsSubmitted(true)
			}, 500)
			console.error('Feedback submission error:', error)
		}
	}

	if (isSubmitted) {
		return (
			<div className="min-h-screen bg-[#0a0e1a] text-white">
				<nav className="bg-[#15202b] py-4">
					<div className="flex justify-between items-center px-4">
						<div className="flex items-center space-x-2 ml-4">
							<Link to="/dashboard" className="flex items-center">
								<img src={Logo} alt="LoadLine Logo" className="h-6 w-auto" />
								<span className="text-xl font-bold text-white ml-1">
									LoadLine
								</span>
							</Link>
						</div>
					</div>
				</nav>

				<div className="flex items-center justify-center min-h-[calc(100vh-72px)] -mt-20">
					<div className="bg-[#15202b] p-8 rounded-lg shadow-lg text-center max-w-2xl w-full mx-4">
						<div className="mb-6">
							<div className="w-20 h-20 mx-auto rounded-full border-4 border-emerald-500 flex items-center justify-center">
								<svg
									className="w-10 h-10 text-emerald-500"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="3"
										d="M5 13l4 4L19 7"
									/>
								</svg>
							</div>
						</div>

						<h2 className="text-3xl font-bold text-white mb-6">
							Thank you for your feedback!
						</h2>

						<div className="flex items-center justify-center flex-wrap gap-2 text-lg">
							<span className="text-gray-300">
								If you change your mind, you can always
							</span>
							<a
								href="https://chromewebstore.google.com/detail/loadlineai/cpcnkckpbpefgkcilhclfdefccflgaif"
								target="_blank"
								rel="noopener noreferrer"
								className="inline-flex items-center gap-2 bg-gray-700 hover:bg-gray-600 border-2 border-sky-400 text-sky-400 px-4 py-2 rounded-lg transition duration-300 font-medium"
							>
								<svg
									className="w-5 h-5"
									fill="currentColor"
									viewBox="0 0 24 24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
								</svg>
								Reinstall
							</a>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div className="min-h-screen bg-[#0a0e1a] text-white">
			<nav className="bg-[#15202b] py-4">
				<div className="flex justify-between items-center px-4">
					<div className="flex items-center space-x-2 ml-4">
						<Link to="/dashboard" className="flex items-center">
							<img src={Logo} alt="LoadLine Logo" className="h-6 w-auto" />
							<span className="text-xl font-bold text-white ml-1">
								LoadLine
							</span>
						</Link>
					</div>
				</div>
			</nav>

			<div className="flex items-center justify-center min-h-[calc(100vh-72px)] px-4">
				<div className="bg-[#15202b] p-5 rounded-lg shadow-lg w-full max-w-2xl">
					{!selectedCategory ? (
						<>
							<h2 className="text-3xl font-bold text-sky-400 mb-2 text-center">
								What made you decide to uninstall?
							</h2>
							<p className="text-lg text-gray-300 mb-4 text-center">
								Your feedback highly appreciated.
							</p>

							<div className="space-y-5 pl-4">
								{feedbackOptions.map(option => (
									<label
										key={option.id}
										className="flex items-center cursor-pointer group"
									>
										<input
											type="radio"
											name="feedback-category"
											value={option.id}
											onChange={() => handleRadioChange(option.id)}
											className="w-4 h-4 text-sky-500 bg-gray-700 border-gray-600 focus:ring-sky-500 focus:ring-1"
										/>
										<span className="ml-3 text-xl text-white group-hover:text-sky-400 transition-colors">
											{option.label}
										</span>
									</label>
								))}
							</div>
						</>
					) : (
						<>
							<div className="flex items-center mb-4">
								<button
									onClick={handleBack}
									className="mr-4 text-gray-400 hover:text-white transition-colors"
									aria-label="Go back"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M15 19l-7-7 7-7"
										/>
									</svg>
								</button>
								<h2 className="text-xl font-bold text-white">
									{getSelectedOption()?.title}
								</h2>
							</div>

							<div className="mb-4">
								<textarea
									value={message}
									onChange={e => setMessage(e.target.value)}
									placeholder={getSelectedOption()?.placeholder}
									className="w-full h-64 p-4 bg-gray-700 border-2 border-sky-500 rounded-lg text-white placeholder-gray-400 focus:border-sky-400 focus:ring-2 focus:ring-sky-500 resize-none"
									autoFocus
								/>
							</div>
						</>
					)}

					<div className="mt-6 space-y-4">
						<div className="flex justify-center">
							<button
								onClick={handleSubmit}
								disabled={
									!selectedCategory || (selectedCategory && !message.trim()) || isSubmitting
								}
								className="w-2/3 bg-sky-500 hover:bg-sky-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white px-6 py-2.5 rounded-md transition duration-300 text-base font-medium flex items-center justify-center mx-auto"
							>
								{isSubmitting ? (
									<>
										<svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
											<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
											<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
										</svg>
										Submitting...
									</>
								) : (
									'Submit & Uninstall'
								)}
							</button>
						</div>
						<div className="flex items-center justify-center gap-6">
							<span className="text-gray-400 text-lg">Changed your mind?</span>
							<a
								href="https://chromewebstore.google.com/detail/loadline-all-in-one-dispa/cpcnkckpbpefgkcilhclfdefccflgaif"
								target="_blank"
								rel="noopener noreferrer"
								className="bg-gray-700 hover:bg-gray-600 border-2 border-sky-400 text-white px-4 py-2 rounded-lg transition duration-300 text-sm font-medium inline-block"
							>
								Keep using LoadLine
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Feedback
